export const DRAWING_PATH_DEFAULTS = {
    thinning: 0.6,
    smoothing: 0.5,
    streamline: 0.5,
    startTaper: 0,
    endTaper: 0,
};
